'use client'

import { IconLoader } from '@tabler/icons-react'
import { createFileRoute } from '@tanstack/react-router'
import * as React from 'react'
import { InviteForm } from '@/features/store-team/components/invite-form'
import { MembersTable } from '@/features/store-team/components/members-table'
import { PendingInvitationsTable } from '@/features/store-team/components/pending-invitations-table'
import { useStoreSlug } from '@/hooks/use-store-slug'
import { useStores } from '@/hooks/use-stores'

export const Route = createFileRoute('/$store/_layout/settings_/team')({
  component: TeamSettingsPage,
})

function TeamSettingsPage() {
  const storeSlug = useStoreSlug()
  const { stores, isLoading } = useStores()

  const currentStore = React.useMemo(() => {
    if (!storeSlug) return null
    return stores.find((store) => store.slug === storeSlug) || null
  }, [storeSlug, stores])

  const isOwner = currentStore?.role === 'owner'

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <IconLoader className="size-6 animate-spin text-muted-foreground" />
      </div>
    )
  }

  if (!currentStore) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-muted-foreground">Loja não encontrada.</p>
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-6 px-4 py-6 lg:px-6">
      <div>
        <h1 className="text-2xl font-semibold text-foreground">
          Gerenciar Time
        </h1>
        <p className="text-sm text-muted-foreground">
          Gerencie os membros que podem acessar e gerenciar sua loja
        </p>
      </div>

      {isOwner && <InviteForm storeId={currentStore.id} />}

      <PendingInvitationsTable storeId={currentStore.id} />

      <MembersTable storeId={currentStore.id} isOwner={isOwner} />
    </div>
  )
}
